import { useCallback } from "react";
import { useQuery } from "./useQuery";
import { MOCK_VELA_SUMMARY } from "../pages/Accounting/Overview/overviewMockData";
import type { VelaSummary } from "../pages/Accounting/Overview/overviewTypes";
import type { QueryResult } from "./types";

/**
 * Vela's cross-sub-page summary for Accounting.
 * Default: populated. ?populated=0 flips to empty for testing.
 */
export function useVelaAccountingSummary(): QueryResult<VelaSummary> {
  const query = useQuery();
  const populated = query.get("populated") !== "0";
  const data: VelaSummary = populated
    ? MOCK_VELA_SUMMARY
    : { totalCount: 0, breakdown: { toReview: 0, missingReceipts: 0, overdueReconcile: 0, pendingAccountant: 0 } };

  const refetch = useCallback(() => {}, []);
  return { data, loading: false, error: null, refetch };
}